import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api`);


export const getCategories = async()=>{

const response = await API.get("/categories/");

return response.data;

};